import type { SVGProps } from 'react';
export const ConnectionIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    stroke="currentColor"
    fill="none"
    strokeWidth="20"
    viewBox="0 0 260 260"
    height="100%"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M204.6,253.2c20.5,0,37.2-16.7,37.2-37.2c0-20.5-16.7-37.2-37.2-37.2c-20.5,0-37.2,16.7-37.2,37.2 C167.4,236.6,184.1,253.2,204.6,253.2z"></path>
    <path d="M55.8,104.4c20.5,0,37.2-16.7,37.2-37.2S76.4,30,55.8,30c-20.5,0-37.2,16.7-37.2,37.2S35.3,104.4,55.8,104.4z"></path>
    <path d="M55.8,104.4v148.8"></path>
    <path d="M118,60h52.6c9.3,0,18.2,2.5,24.8,7s10.3,10.6,10.3,17v84"></path>
  </svg>
);
